// import React from "react";
// import Slider from "react-slick";
// import gsap from "gsap";
// import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'

import Header from '../components/header'
import Footer from '../components/footer'
import MakeAppoinment from '../components/make-appoinment';
import Filter from "../components/Marketfilter";
import useGaspAnimations from '../components/useGsapAnimations'

function MarketGasChemical() {
     useGaspAnimations()
     
     const lenis = new Lenis({
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)

    
     var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        // initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 2000,
       
      };
    return(
      <section id="smooth-wrapper">
          <Header/>
          <main>
          {/* <!--Start breadcrumb area-->      */}
                {/* <section className="breadcrumb-area">
                    <div className="container text-center">
                        <h1>Heat Pumps</h1>
                    </div>
                </section> */}
                {/* <!--End breadcrumb area--> */}

                {/* <!--Start breadcrumb bottom area--> */}
                {/* <section className="breadcrumb-botton-area">
                    <div className="container">
                        <div className="left">
                            <ul>
                                <li><a href="/">Home</a></li>
                                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                                <li><a href="services.html">Market</a></li>
                                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                                <li className="active">Oil / Gas / Chemical </li>
                            </ul>    
                        </div>
                    </div>
                </section> */}
                {/* <!--End breadcrumb bottom area--> */}

                {/* <!--Start service single area--> */}
                <section id="service-single-area">
                    <div className="container">
                        <div className="row">
                             <Filter/>      
                            <div className="col-lg-9 col-md-8 col-sm-12 col-xs-12 pull-right">
                                <div className="service-single-content">
                                    {/* <!--Start top content --> */}
                                    <div className="row top-content">
                                        <div className="col-md-5 col-sm-12 col-xs-12">
                                            <div className="img-holder wow zoomInStable animated bdFadeUp">
                                                  {/* <Slider {...settings}>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                  </Slider> */}
                                                   <img src="assets/images/Market-Images/06.webp" alt="Awesome Image"/>
                                             
                                            </div>
                                        </div>
                                        <div className="col-md-7 col-sm-12 col-xs-12">
                                            <div className="textholder">
                                                <div className="sec-title bdFadeUp">
                                                    <h1><span>Oil, Gas & Chemical Industry</span></h1>
                                                </div>
                                                <div className="text bdFadeUp">
                                                    <span>Robust Industrial Refrigeration for Critical Process Applications</span>
                                                    <p className="top">
                                                      Indus Refrigeration delivers high-capacity, mission-critical refrigeration and chilling systems tailored to the demanding environments of the oil, gas, and chemical industries. Known for engineering excellence and reliability, Indus designs custom solutions that support safe, efficient, and continuous operations in refineries, petrochemical plants, fertilizer units, and specialty chemical manufacturing facilities.
                                                    </p>
                                                    <p>
                                                      Our industrial-grade refrigeration systems are built to handle extreme process conditions such as high ambient temperatures, corrosive chemicals, and volatile substances. From gas dehydration to chemical reaction cooling, Indus ensures temperature precision and operational stability through robust design and advanced automation.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!--End top content --> */}
                                    {/* <div className="row">
                                        <div className="col-md-12">
                                            <div className="border"></div>
                                        </div>
                                    </div> */}
                                     <div className="row">
                                        <div className="col-md-12">
                                            <div className="project-description">
                                                <div className="sec-title bdFadeUp">
                                                    <h2>Key Offerings for the Oil, Gas & Chemical Sector:</h2>
                                                </div>
                                                    <p>Low-temperature refrigeration systems for gas compression and liquefaction</p>

                                                    <p>Brine and glycol chillers for process cooling and heat removal</p>

                                                    <p>Ammonia-based systems for large-scale industrial applications</p>

                                                    <p>Explosion-proof and corrosion-resistant equipment design</p>

                                                    <p>Cooling solutions for reactors, condensers, and storage tanks</p>

                                                    <p>Customized turnkey execution including system design, fabrication, instrumentation, and control</p>

                                                    <p>Indus systems are designed with a focus on safety, compliance, and longevity—meeting the most rigorous industry standards including ATEX, ASME, API, and ISO certifications. Our expertise in handling flammable and hazardous environments makes us a trusted partner for energy and chemical processing companies across India and international markets.</p>
                                               </div>    
                                        </div>
                                    </div>
  
                                </div>
                            </div>  
                        </div>
                    </div>    
                </section>
                {/* <!--End service single area--> */}
                 {/* <!--Start Consultation form--> */}
                     <MakeAppoinment/>
                    {/* <!--End Consultation form--> */}
          </main>
          <Footer/>
      </section>
    )
 }
 
 export default MarketGasChemical;


